import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const userAccess = (to, from, next) => {
  next()
}

class Page {
  constructor(path = null, component = null, name = null, props = false, beforeEnter = userAccess) {
    this.path = path
    this.name = name
    this.component = () => import(`@/pages/${component}`)
    this.beforeEnter = beforeEnter
    this.props = props
  }
}

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: { name: 'zvp' }},
    new Page('/login', 'auth/Login', 'login'),
    new Page('/registration/:username/:code', 'auth/Registration', 'registrationConfirm'),
    new Page('/registration', 'auth/Registration', 'registration'),
    new Page('/forget', 'auth/ForgetPassword', 'forget'),
    new Page('/forget/:username/:code', 'auth/ForgetPassword', 'forgetConfirm'),

/*    {
      ... new Page('/admin', 'admin/index', 'admin'),
      redirect: { name: 'userParent' },
      children: [
        new Page('user', 'admin/UserParent', 'userParent'),
        new Page('role', 'admin/RoleParent', 'roleParent'),
        new Page('userGroup', 'admin/UserGroupParent', 'userGroupParent'),
      ]
    },*/

    new Page('*', 'NotFoundPage', 'notFoundPage'),

    {
      ...new Page('/zvp', 'zvp/Index', 'zvp'),
      redirect: { name: 'applications' },
      children: [
        new Page('applications', 'zvp/Applications', 'applications'),
        new Page('application-read/:id', 'zvp/ApplicationRead', 'applicationRead'),

        {
          ... new Page('notification', 'zvp/notificationManagement/index', 'notification'),
          redirect: { name: 'massNotifications' },
          children: [
            new Page('mass-notifications', 'zvp/notificationManagement/MassNotifications', 'massNotifications'),
            new Page('report-summary', 'zvp/notificationManagement/ReportSummary', 'reportSummary'),
            new Page('individual-notifications', 'zvp/notificationManagement/IndividualNotifications', 'individualNotifications')
          ]
        },

        new Page('vacancies', 'zvp/Vacancies', 'vacancies'),

        new Page('contest-page', 'zvp/contest-page/ContestPage', 'contestPage'),
        new Page('contest-line-page/:id', 'zvp/contest-page/ContestLinePage', 'contestLinePage'),

        new Page('test-results', 'zvp/test-results/TestResult', 'testResult'),

        {
          ... new Page('documentation-setup', 'zvp/documentationSetup/index', 'documentationSetup'),
          redirect: { name: 'protocols' },
          children: [
            new Page('protocols', 'zvp/documentationSetup/protocols/Protocols', 'protocols'),
            new Page('protocol-line/:id', 'zvp/documentationSetup/protocols/ProtocolLine', 'protocolLine'),

            new Page('orders', 'zvp/documentationSetup/orders/Orders', 'orders'),
            new Page('order-line/:id', 'zvp/documentationSetup/orders/OrderLine', 'orderLine'),
          ]
        },

        new Page('deadlines', 'zvp/DeadlinesPage', 'deadlinesPage'),

        {
          ... new Page('system', 'zvp/systemSettings/index', 'systemSettings'),
          redirect: { name: 'dictionaries' },
          children: [
            {
              ...new Page('dictionaries', 'zvp/systemSettings/dictionaries/index', 'dictionaries'),
              children: [
                new Page('acadamy-years', 'zvp/systemSettings/dictionaries/AcadamyYears', 'acadamyYears'),
                new Page('achievement', 'zvp/systemSettings/dictionaries/Achievement', 'achievement'),
                new Page('department', 'zvp/systemSettings/dictionaries/Department', 'department'),
                new Page('speciality', 'zvp/systemSettings/dictionaries/Speciality', 'speciality'),
                new Page('application-status', 'zvp/systemSettings/dictionaries/ApplicationStatus', 'applicationStatus'),
                new Page('card-type', 'zvp/systemSettings/dictionaries/CardType', 'cardType'),
                new Page('gender', 'zvp/systemSettings/dictionaries/Gender', 'gender'),
                new Page('semester-type', 'zvp/systemSettings/dictionaries/SemesterType', 'semesterType'),
                new Page('country-region', 'zvp/systemSettings/dictionaries/CountryRegion', 'countryRegion'),
                new Page('groups', 'zvp/systemSettings/dictionaries/Groups', 'groups'),
                new Page('scholarship-type', 'zvp/systemSettings/dictionaries/ScholarshipTypes', 'scholarshipType'),
                new Page('submission-session', 'zvp/systemSettings/dictionaries/SubmissionSession', 'submissionSession'),
              ]
            },
            // new Page('roles', 'zvp/systemSettings/roles/index', 'roles')
          ]
        },

        new Page('submission-session', 'zvp/SubmissionSession', 'submissionSession'),
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
